import MenifestInfoDialog from './menifestInfoDialog';
export default MenifestInfoDialog;